// export const API="https://maneemfi.com/";
export const API="https://api.app.maneecafe.com/";

// export const APIMERTRADE="https://api.mertrades.com/";

// export const API="http://192.168.100.185:8000";